var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, functionType="function", escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  
  return "\n      <p class=\"article-list-thumbnail-new-icon js-article-new-label\">NEW</p>\n    ";
  }

function program3(depth0,data) {
  
  
  return "\n        <p class=\"p-article-info__premium-label\">プレミアム記事</p>\n      ";
  }

function program5(depth0,data) {
  
  
  return "\n        <img class=\"p-article-info__sponsor-label\" src=\"//cdn.mamari.jp/static/mamariQ/img/common/sponsor-label.png\">\n      ";
  }

function program7(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n        ";
  stack1 = helpers.unless.call(depth0, ((stack1 = (depth0 && depth0.Article)),stack1 == null || stack1 === false ? stack1 : stack1.is_premium), {hash:{},inverse:self.noop,fn:self.program(8, program8, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      ";
  return buffer;
  }
function program8(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n          <p class=\"p-article-info__fav\">\n            "
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.Article)),stack1 == null || stack1 === false ? stack1 : stack1.favorite_count)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\n          </p>\n        ";
  return buffer;
  }

  buffer += "<a href=\"http://mamari.jp/"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.Article)),stack1 == null || stack1 === false ? stack1 : stack1.id)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "?utm_source=mamariq_app&utm_medium="
    + escapeExpression(((stack1 = (depth0 && depth0.utmMedium)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\">\n  <div class=\"article-list-thumbnail-wrapper\">\n    <img class=\"article-list-thumbnail\" src=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.Article)),stack1 == null || stack1 === false ? stack1 : stack1.image_url)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\" alt=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.Article)),stack1 == null || stack1 === false ? stack1 : stack1.og_title)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\">\n    ";
  stack1 = helpers.unless.call(depth0, ((stack1 = (depth0 && depth0.Article)),stack1 == null || stack1 === false ? stack1 : stack1.is_read), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </div>\n  <div class=\"article-list-title-and-sub-info\">\n    <p class=\"article-title\">\n      "
    + escapeExpression(__default(require("../js/hbs_helpers/truncate.js")).call(depth0, ((stack1 = (depth0 && depth0.Article)),stack1 == null || stack1 === false ? stack1 : stack1.og_title), 84, {hash:{},data:data}))
    + "\n    </p>\n    <div class=\"p-article-info\">\n      ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.Article)),stack1 == null || stack1 === false ? stack1 : stack1.is_premium), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      <p class=\"p-article-info__name\">"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.MamariUser)),stack1 == null || stack1 === false ? stack1 : stack1.name)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</p>\n      ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.Article)),stack1 == null || stack1 === false ? stack1 : stack1.is_sponsored), {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.showFavoriteCount), {hash:{},inverse:self.noop,fn:self.program(7, program7, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </div>\n  </div>\n</a>\n";
  return buffer;
  });


//////////////////
// WEBPACK FOOTER
// ./webroot/hbs/article_list_content.hbs
// module id = 188
// module chunks = 0 1